// Copyright (c) 2019 Deere & Company

import './warranty-link.scss';
import React, {
    PropTypes
} from 'react';

import {FormattedMessage} from 'react-intl';

const WarrantyLink = ({handleWarrantyLink}) =>
    <span className='warranty-link'>
        <button
            className='button-text'
            onClick={handleWarrantyLink}
        >
            <FormattedMessage id='WARRANTY_COVERAGE'/>
        </button>
    </span>;

WarrantyLink.displayName = 'WarrantyLink';
WarrantyLink.propTypes = {
    handleWarrantyLink: PropTypes.func.isRequired
};

export default WarrantyLink;



// WEBPACK FOOTER //
// ./src/claim/shared/components/warranty-link.js